import Resource from '@/plugins/sdk/Resource'
import { UUID, DATETIME, ITEM } from '@/plugins/sdk/fields'
import AccountEvent from '@/plugins/sdk/resources/Account/Event'

export default class extends Resource {
  static name = 'account_event_defer'

  static get fields () {
    return {
      id: new UUID(),
      event: new ITEM(AccountEvent),
      created_at: new DATETIME(),
      updated_at: new DATETIME(),
      deleted_at: new DATETIME()
    }
  }
}
